// components
import { styled, ListItemText, ListItemTextProps } from '@mui/material';

export const StyledListItemText = styled(ListItemText)<ListItemTextProps>(
  ({ theme }) => ({
    maxWidth: '160px',
    paddingRight: theme.spacing(3)
  })
);
